import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Login from '@/views/Login'
import store from './store'

Vue.use(Router)

export default new Router({
	base: '/payments',
	mode: 'history',
	routes: [
		{
			path: '/',
			meta: { requiresAuth: true },
			component: Home
		},
		{
			path: '/form',
			name: 'form',
			meta: { requiresAuth: true },
			component: Home,
			beforeEnter(from, to, next) {
				store
					.dispatch('FINANCING')
					.then(next)
					.catch(() => next('/login'))
			}
		},
		{
			name: 'login',
			path: '/login',
			meta: { requiresAuth: false },
			component: Login
		}
	]
})
